export const parseStartOfDayFromQueryParam = (value: string | null) => {
  if (!value) {
    return undefined;
  }

  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return undefined;
  }

  const date = new Date(`${value}T00:00:00`);
  date.setHours(0, 0, 0, 0);
  if (!Number.isFinite(date.getTime())) {
    return undefined;
  }

  return date;
};
